/* 21/09/2026 — hoãn ảnh cho tới khi nó thật sự sắp lộ ra.
   `loading="lazy"` của trình duyệt tính khoảng cách rất rộng rãi: đo ngày 21/09 trên
   trang chủ 4G, khi CHƯA cuộn dòng nào đã có 69/127 ảnh tải xong, trong đó chỉ 5 tấm
   nằm trong tầm nhìn — 40 tấm nằm ngoài mép phải các băng vuốt và 13 tấm nằm trong
   ngăn giỏ đang đóng. Ảnh nào mang data-nh-src thì chỉ được gắn src khi
   IntersectionObserver thấy nó sắp vào tầm nhìn, nên băng vuốt tải theo nhịp vuốt
   và ngăn giỏ tải khi khách mở giỏ.

   Lưới an toàn: sau khi trang tải xong, ảnh nào còn trống mà lại đang nằm trong tầm
   nhìn thì gắn ngay — chỉ tấm đang nhìn thấy, không kéo theo phần ngoài màn hình. */
(function () {
  'use strict';

  var SEL = 'img[data-nh-src]';

  function show(img) {
    if (!img || !img.dataset || !img.dataset.nhSrc) return;
    var srcset = img.dataset.nhSrcset;
    var src = img.dataset.nhSrc;
    delete img.dataset.nhSrc;
    delete img.dataset.nhSrcset;
    if (srcset) img.setAttribute('srcset', srcset.replace(/\s+/g, ' ').trim());
    img.setAttribute('src', src);
  }

  function showAll(root) {
    (root || document).querySelectorAll(SEL).forEach(show);
  }

  if (!('IntersectionObserver' in window)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { showAll(); });
    else showAll();
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      show(entries[i].target);
      io.unobserve(entries[i].target);
    }
    // Tầm nhìn trước ≈ 0,8 màn (tối thiểu 600px): đo ngày 21/09, mức 400px còn để lọt một
    // hai ô trống khi cuộn nhanh trên 4G, và màn máy tính cao hơn thì cần rộng hơn nữa —
    // vẫn xa mức ~1250px mà `loading="lazy"` của Chrome tự lấy.
    // 500px ngang đủ cho một thẻ rưỡi của băng vuốt.
  }, { rootMargin: Math.max(600, Math.round((window.innerHeight || 800) * 0.8)) + 'px 500px' });

  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(function (img) {
      if (img.dataset.nhObs) return;
      img.dataset.nhObs = '1'; // để công cụ đo phân biệt "chưa quan sát" với "quan sát rồi mà chưa tới lượt"
      io.observe(img);
    });
  }

  scan();

  /* Ngăn giỏ và menu kéo: chúng nằm trong khung `overflow:hidden` cao đúng một màn,
     nên phần dưới bị cắt hoàn toàn và IntersectionObserver không bao giờ thấy — khách
     mở giỏ ra sẽ gặp ô trống cho tới khi cuộn. Khi một ngăn mở, gắn hết ảnh trong nó:
     lúc đó khách đã chủ động mở, và mỗi ngăn chỉ có hơn chục tấm. */
  var PANELS = 'cart-drawer, .drawer, .menu-drawer, .cart-notification';
  var panelMo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var el = records[i].target;
      if (el.classList.contains('active') || el.classList.contains('is-open') || el.classList.contains('menu-opening') || el.hasAttribute('open')) showAll(el);
    }
  });
  function watchPanels(root) {
    (root || document).querySelectorAll(PANELS).forEach(function (el) {
      if (el.nhPanelWatched) return;
      el.nhPanelWatched = true;
      panelMo.observe(el, { attributes: true, attributeFilter: ['class', 'open'] });
    });
  }
  watchPanels();
  // Menu kéo mở bằng <details open>, không đổi class trên chính ngăn.
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.tagName === 'DETAILS' && t.open) showAll(t);
  }, true);

  /* Giỏ, bộ lọc bộ sưu tập, quick add… thay cả khối HTML — phải quét phần vừa thêm.
     Các app trên trang chèn node liên tục, nên không quét ngay trong callback: dồn vào
     hàng đợi rồi xử lý một lượt lúc trình duyệt rảnh, khỏi cộng thêm vào những tác vụ
     dài vốn đã nhiều trên máy điện thoại. */
  var queued = [];
  var flushing = false;
  function flush() {
    flushing = false;
    var nodes = queued;
    queued = [];
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (!n.isConnected) continue;
      if (n.matches && n.matches(SEL)) io.observe(n);
      if (n.querySelectorAll) { scan(n); watchPanels(n); }
    }
  }
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 32); };
  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) queued.push(added[j]);
      }
    }
    if (queued.length && !flushing) { flushing = true; idle(flush, { timeout: 400 }); }
  });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });

  /* IntersectionObserver lo phần tải TRƯỚC khi ảnh lộ ra. Vòng này lo phần còn lại: ảnh đã
     thật sự vào khung mà observer chưa kịp báo (đo 21/09: cuộn nhảy 0,7 màn trên máy tính
     còn bắt gặp một hai tấm như vậy). Chạy tối đa mỗi khung hình, và tự gỡ khi không còn
     ảnh nào chờ. `capture` để nghe cả cuộn bên trong băng vuốt và ngăn giỏ. */
  var scrollTick = false;
  function onScroll() {
    if (scrollTick) return;
    scrollTick = true;
    requestAnimationFrame(function () {
      scrollTick = false;
      var left = document.querySelectorAll(SEL);
      if (!left.length) { window.removeEventListener('scroll', onScroll, true); return; }
      var vh = window.innerHeight, vw = window.innerWidth;
      for (var i = 0; i < left.length; i++) {
        var r = left[i].getBoundingClientRect();
        if (r.width && r.bottom > -50 && r.top < vh + 50 && r.right > -50 && r.left < vw + 50) show(left[i]);
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true, capture: true });

  window.addEventListener('load', function () {
    setTimeout(function () {
      var vh = window.innerHeight, vw = window.innerWidth;
      document.querySelectorAll(SEL).forEach(function (img) {
        var r = img.getBoundingClientRect();
        if (r.width && r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw) show(img);
      });
    }, 3000);
  });
})();

/* ---------------------------------------------------------------------------
   Ảnh thứ hai của thẻ sản phẩm — chỉ tải khi máy có chuột và con trỏ tới thẻ.
   base.css chỉ đổi sang ảnh đó ở `.card-wrapper:hover`, nên trên điện thoại và
   máy tính bảng nó hoàn toàn vô hình. Thẻ nhận class nh-hover-image-ready sau khi
   ảnh tải xong, để lúc chưa xong vẫn giữ ảnh chính (luật đè ở nh-trust-blocks.css).
   Gộp vào đây 21/09/2026: hai tệp nhỏ tách riêng tốn thêm một lượt đi về mạng,
   trên 4G là ~150ms tranh chỗ với chính ảnh đang cần vẽ.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var SELECTOR = 'img.nh-card-hover-image[data-nh-hover-src]';
  var canHover = false;
  try {
    canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  } catch (e) {
    canHover = false;
  }
  if (!canHover) return;

  function load(img) {
    if (!img || !img.dataset.nhHoverSrc) return;
    var srcset = img.dataset.nhHoverSrcset;
    var src = img.dataset.nhHoverSrc;
    delete img.dataset.nhHoverSrc;
    delete img.dataset.nhHoverSrcset;

    var card = img.closest('.card-wrapper') || img.closest('.card');
    function ready() {
      if (card) card.classList.add('nh-hover-image-ready');
    }
    img.addEventListener('load', ready, { once: true });
    img.addEventListener('error', ready, { once: true });

    if (srcset) img.setAttribute('srcset', srcset.replace(/\s+/g, ' ').trim());
    img.setAttribute('src', src);
    if (img.complete && img.naturalWidth) ready();
  }

  function fromEvent(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var card = target.closest('.card-wrapper, .card');
    if (!card) return;
    var img = card.querySelector(SELECTOR);
    if (img) load(img);
  }

  document.addEventListener('pointerover', fromEvent, { capture: true, passive: true });
  // Bàn phím: người dùng tab tới liên kết thẻ cũng thấy hiệu ứng đổi ảnh.
  document.addEventListener('focusin', fromEvent, { capture: true, passive: true });
})();
